// Layout Constants
export const LAYOUT = {
  headerHeight: "56px",      // Standard header height
  sidebarWidth: "320px",     // Standard sidebar width
  contentMaxWidth: "1440px", // Max width for main content area
  minWidth: "1280px",        // Minimum supported width
  minHeight: "800px",        // Minimum supported height
};

// Grid System
export const GRID = {
  columns: 12,
  gutter: "1.5rem", // Standard gutter width
  containerWidth: {
    sm: "640px",
    md: "768px",
    lg: "1024px",
    xl: "1280px",
    "2xl": "1536px",
  },
};

// Card & Section Styles
export const CARD_BASE = "bg-white dark:bg-neutral-800 rounded-lg shadow-sm border border-neutral-200 dark:border-neutral-700 transition-shadow hover:shadow-md";
export const SECTION_PADDING = "p-4";

// Responsive Breakpoints
export const BREAKPOINTS = {
  sm: "640px",
  md: "768px",
  lg: "1024px",
  xl: "1280px",
  "2xl": "1536px",
};

// Z-index Scale
export const Z_INDEX = {
  hide: -1,
  base: 0,
  raised: 1,
  dropdown: 10,
  sticky: 20,
  header: 30,
  modal: 40,
  popover: 50,
  toast: 60,
  tooltip: 70,
};

// Common Spacing
export const SPACING = {
  xs: "0.25rem",  // 4px
  sm: "0.5rem",   // 8px
  md: "1rem",     // 16px
  lg: "1.5rem",   // 24px
  xl: "2rem",     // 32px
  "2xl": "2.5rem" // 40px
}; 